export function b64ToBlob(base64: string, type = 'application/octet-stream', callback: (blob: any) => void): void {
    const byteArrays: any[] = [];
    const sliceSize: number = 512;
    let byteCharacters: string;

    try {
        let b64Copy = base64;
        // Entferne Prefix "data:image/jpeg;base64,"
        b64Copy = b64Copy.split(',')[1] || b64Copy;
        // Entferne Leerzeichen
        b64Copy = b64Copy.replace(/\s/g, '');
        byteCharacters = window.atob(b64Copy);
    } catch (e) {
        console.log(e);
    }

    if (byteCharacters) {
        for (let offset: number = 0; offset < byteCharacters.length; offset += sliceSize) {
            const slice: string = byteCharacters.slice(offset, offset + sliceSize);
            const byteNumbers: number[] = new Array(slice.length);

            for (let i: number = 0; i < slice.length; ++i) {
                byteNumbers[i] = slice.charCodeAt(i);
            }
            const byteArray: Uint8Array = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
    }

    if (typeof callback === 'function') {
        callback(new Blob(byteArrays, { type }));
    }

    // fetch(`data:${type};base64,${base64}`)
    //     .then(res => res.blob())
    //     .then(callback);
}
